import React from "react";

const TermsAndConditions = () => {
  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        padding: "20px",
        maxWidth: "800px",
        margin: "auto",
      }}
    >
      <h1 style={{ textAlign: "center", color: "#007BFF", fontSize: 38 }}>
        Terms and Conditions
      </h1>
      <p>
        Welcome to <strong>Blue Washer</strong>. By accessing or using our
        services, you agree to comply with and be bound by the following terms
        and conditions. Please read these terms carefully before using our
        services.
      </p>

      <h2 className="mt-4 font-bold">1. Use of Services</h2>
      <p>Our services are intended for personal and non-commercial use.</p>

      <h2 className="mt-4 font-bold">2. Booking and Payments</h2>
      <p>
        All bookings are subject to availability. Payment must be completed
        through our secure payment gateway, cash or UPI. We reserve the right to
        cancel or modify bookings in cases of unforeseen circumstances.
      </p>
      <p style={{ marginTop: "10px" }}>
        <strong>Note:</strong> TATA Harrier,MG Hector, Mahindra Thar, and Thar
        Roxx will be treated as seven-seater vehicles for billing purposes.
        Pricing will be calculated accordingly.
      </p>

      <h2 className="mt-4 font-bold">3. Service Limitations</h2>
      <p>
        While we strive for excellence, certain factors such as weather
        conditions or prior vehicle damage may affect the outcome of our
        services. We do not guarantee a specific result in such cases.
      </p>

      <h2 className="mt-4 font-bold">4. User Responsibilities</h2>
      <p>
        Users are responsible for providing accurate information during booking
        and ensuring access to the vehicle at the agreed location and time.
        Failure to do so may result in additional charges or service
        cancellation.
      </p>

      <h2 className="mt-4 font-bold">5. Cancellations and Refunds</h2>
      <p>
        Cancellation requests must be made at least 24 hours before the
        scheduled service time. Refunds will be processed in accordance with our
        refund policy, which may include deductions for administrative fees.
      </p>

      <h2 className="mt-4 font-bold">6. Intellectual Property</h2>
      <p>
        All content on the Blue Washer website, including text, graphics, logos,
        and images, is the property of Blue Washer and is protected by
        applicable copyright and trademark laws. Unauthorized use of our content
        is strictly prohibited.
      </p>

      <h2 className="mt-4 font-bold">7. Liability</h2>
      <p>
        Blue Washer is not liable for any direct, indirect, incidental, or
        consequential damages arising from the use of our services, except where
        required by law. Users assume all risks associated with using our
        services.
      </p>

      <h2 className="mt-4 font-bold">8. Account Suspension Policy</h2>
      <p>
        Blue Washer exclusively offers doorstep car wash services, with no
        intermediaries allowed on the platform. Any misconduct toward our
        washing partners or failure to pay washing charges will result in
        account suspension.
      </p>

      <h2 className="mt-4 font-bold">9. Changes to Terms</h2>
      <p>
        We reserve the right to update or modify these terms at any time without
        prior notice. Continued use of our services signifies acceptance of the
        updated terms.
      </p>

      <h2 className="mt-4 font-bold">10. Governing Law</h2>
      <p>
        These terms and conditions are governed by and construed in accordance
        with the laws of Raigarh Jurisdiction. Any disputes arising from these
        terms shall be subject to the exclusive jurisdiction of the courts in
        Raigarh.
      </p>

      <h2 className="mt-4 font-bold">Contact Us</h2>
      <p>
        If you have any questions about these Terms and Conditions, please
        contact us at
        <a href="mailto:support@bluewasher.com" style={{ color: "#007BFF" }}>
          {" "}
          support@bluewasher.com
        </a>
        .
      </p>

      <p style={{ textAlign: "center", marginTop: "20px" }}>
        <em>Last updated: 19th Jan 2025</em>
      </p>
    </div>
  );
};

export default TermsAndConditions;
